import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import MyIconButton from "./myiconbutton";

const DeleteIconButton = ({onClick, style, autoFocus, disabled}) => (
    <MyIconButton icon={<DeleteIcon/>} onClick={onClick} autoFocus={autoFocus} style={style} disabled={disabled}/>
)

export default DeleteIconButton;
